var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66013_52796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6484 10.6516L11.9797 11.9829L14.6423 9.32031",
    stroke: "#111D31",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9816 6.65975V5.32845C13.9814 5.09499 13.9198 4.8657 13.8029 4.66358C13.6861 4.46146 13.5182 4.29361 13.316 4.17688L8.65647 1.5143C8.45409 1.39745 8.22451 1.33594 7.99082 1.33594C7.75713 1.33594 7.52756 1.39745 7.32518 1.5143L2.66565 4.17688C2.46346 4.29361 2.29553 4.46146 2.1787 4.66358C2.06187 4.8657 2.00024 5.09499 2 5.32845V10.6536C2.00024 10.8871 2.06187 11.1164 2.1787 11.3185C2.29553 11.5206 2.46346 11.6885 2.66565 11.8052L7.32518 14.4678C7.52756 14.5846 7.75713 14.6461 7.99082 14.6461C8.22451 14.6461 8.45409 14.5846 8.65647 14.4678L9.98776 13.7089",
    stroke: "#111D31",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 2.85156L10.983 6.27964",
    stroke: "#111D31",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 4.64844L7.98528 7.97667L13.7831 4.64844",
    stroke: "#111D31",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 14.6487V7.99219",
    stroke: "#111D31",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66013_52796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9755,
    height: 15.9755,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishing);
export default __webpack_public_path__ + "static/media/finishing.c0f6da49257b54173370275a4f335ae3.svg";
export { ForwardRef as ReactComponent };